import { motion } from 'framer-motion';

const clients = [
  '/images/clientes-carrosel/15844843305e714feab8e1d_1584484330_1x1_md.jpg',
  '/images/clientes-carrosel/Accenture.svg.png',
  '/images/clientes-carrosel/estadao-logo-0.png',
  '/images/clientes-carrosel/images.png',
  '/images/clientes-carrosel/JK IGUATEMI.png',
  '/images/clientes-carrosel/Logotipoelinox-1519731508.png',
  '/images/clientes-carrosel/scania-logo-png_seeklogo-123303.png',
  '/images/clientes-carrosel/Skechers.svg.png',
];

const ClientsCarousel = () => {
  // Duplicar o array para criar efeito infinito
  const duplicatedClients = [...clients, ...clients];

  return (
    <section className="section-padding bg-gradient-to-br from-white via-conforto/5 to-white overflow-hidden">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-natureza font-semibold text-sm uppercase tracking-wider">
            Parcerias
          </span>
          <h2 className="text-floresta font-display mt-4">
            Nossos <span className="text-natureza italic">Clientes</span>
          </h2>
        </motion.div>
      </div>

      {/* Carousel Container */}
      <div className="relative">
        {/* Gradient Overlays nas bordas */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />

        {/* Sliding Track */}
        <motion.div
          className="flex gap-8 items-center"
          animate={{
            x: [0, -(192 + 32) * clients.length],
          }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 40,
              ease: "linear",
            },
          }}
        >
          {duplicatedClients.map((client, index) => (
            <div
              key={index}
              className="flex-shrink-0 w-48 h-32 flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-500 hover:scale-110"
            >
              <img
                src={client}
                alt={`Cliente ${index + 1}`}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default ClientsCarousel;
